<template>
  <div>
    <v-container fill-height id="container" class="pa-0">
      <v-row v-resize="onResize" class="pa-0 ma-0">
        <v-col id="content" class="pa-0 ma-0">
          <img id="desk" :src="currentImg">
          <span>{{imageDisplay()}}</span>
          <h1>Coming Soon...</h1>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    data: () => ({
      windowSize: {
        x: 0,
        y: 0,
      },
      currentImg: ""
    }),

    mounted () {
      this.onResize()
    },

    methods: {
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      },
      imageDisplay: function() {
        if(this.windowSize.y <= 700){
          this.currentImg = require('../assets/landingImageCableCloserShorterExtra.svg')
        }
        if(this.windowSize.y <= 900 && this.windowSize.y > 700){
          this.currentImg = require('../assets/landingImageCableCloserShorter.svg')
          }
        if(this.windowSize.x < 600 && this.windowSize.y > 700){
          this.currentImg = require('../assets/landingImageCableCloser.svg')
        }
        if(this.windowSize.y > 900 && this.windowSize.y < 1300){
          this.currentImg = require('../assets/landingImageCableCloser.svg')
        }
        if(this.windowSize.y >= 1300){
          this.currentImg = require('../assets/landingImageCableCloserLonger.svg')
        }
      },
    },
    watch: {
      onResize(){
        this.imageDisplay();
      }
    },
  }
</script>

<style lang="scss" scoped>
#container{
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  max-width: 975px;
  margin: 0 auto;
}


h1{
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-size: 2rem;
}

</style>